import { render, staticRenderFns } from "./ShipmentNextStatus.vue?vue&type=template&id=45e8963c&scoped=true"
import script from "./ShipmentNextStatus.vue?vue&type=script&lang=js"
export * from "./ShipmentNextStatus.vue?vue&type=script&lang=js"
import style0 from "./ShipmentNextStatus.vue?vue&type=style&index=0&id=45e8963c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e8963c",
  null
  
)

export default component.exports